(function() {
  function initFlipbook(container) {
    if (!container) return;

    const images = [
      "https://cdn.shopify.com/s/files/1/0815/7714/8710/files/Seite0.jpg?v=1771926645",
      "https://cdn.shopify.com/s/files/1/0815/7714/8710/files/Seite1.jpg?v=1772201364",
      "https://cdn.shopify.com/s/files/1/0815/7714/8710/files/Seite2.jpg?v=1772202676",
      "https://cdn.shopify.com/s/files/1/0815/7714/8710/files/Seite3.jpg?v=1772202689",
      "https://cdn.shopify.com/s/files/1/0815/7714/8710/files/Seite4.jpg?v=1772202701",
      "https://cdn.shopify.com/s/files/1/0815/7714/8710/files/Seite5.jpg?v=1772202713",
      "https://cdn.shopify.com/s/files/1/0815/7714/8710/files/Seite6.jpg?v=1772202725",
      "https://cdn.shopify.com/s/files/1/0815/7714/8710/files/Seite7.jpg?v=1772202733",
      "https://cdn.shopify.com/s/files/1/0815/7714/8710/files/Seite8.jpg?v=1772202742",
      "https://cdn.shopify.com/s/files/1/0815/7714/8710/files/Seite9.jpg?v=1772205475",
      "https://cdn.shopify.com/s/files/1/0815/7714/8710/files/Seite10.jpg?v=1772205506",
      "https://cdn.shopify.com/s/files/1/0815/7714/8710/files/Seite11.jpg?v=1772205538",
      "https://cdn.shopify.com/s/files/1/0815/7714/8710/files/Seite12.jpg?v=1772205562",
      "https://cdn.shopify.com/s/files/1/0815/7714/8710/files/Seite13.jpg?v=1772205583",
      "https://cdn.shopify.com/s/files/1/0815/7714/8710/files/Seite14.jpg?v=1772544098",
      "https://cdn.shopify.com/s/files/1/0815/7714/8710/files/Seite15_b5fe5b58-1d70-490f-aa36-7f46dddf389e.jpg?v=1772544303",
      "https://cdn.shopify.com/s/files/1/0815/7714/8710/files/Seite16.jpg?v=1772554453",
      "https://cdn.shopify.com/s/files/1/0815/7714/8710/files/Seite17.jpg?v=1772554790",
      "https://cdn.shopify.com/s/files/1/0815/7714/8710/files/Seite18.jpg?v=1772554790",
      "https://cdn.shopify.com/s/files/1/0815/7714/8710/files/Seite19.jpg?v=1772554790",
      "https://cdn.shopify.com/s/files/1/0815/7714/8710/files/Seite20.jpg?v=1772554791",
      "https://cdn.shopify.com/s/files/1/0815/7714/8710/files/Seite15.jpg?v=1771926645"
    ];

    const book = new St.PageFlip(container.querySelector("#flipbook"), {
      width: 1000,
      height: 1400,
      size: "stretch",
      minWidth: 315,
      maxWidth: 1200,
      minHeight: 400,
      maxHeight: 1533,
      showCover: false,
      usePortrait: true,
      spread: true,
      drawShadow: true,
      flippingTime: 800
    });

    book.loadFromImages(images);
    book.flip(0);

    const pageIndicator = container.querySelector("#page-indicator");
    function updatePageIndicator() {
      const current = book.getCurrentPageIndex();
      const left = current;
      const right = (current+1 < images.length) ? current+1 : current;
      pageIndicator.textContent = left + "–" + right + " von " + (images.length-1);
    }

    book.on("flip", updatePageIndicator);
    updatePageIndicator();

    container.querySelector("#prev").onclick = () => book.flipPrev();
    container.querySelector("#next").onclick = () => book.flipNext();
    container.querySelector("#first").onclick = () => book.flip(0);
    container.querySelector("#last").onclick = () => book.flip(images.length-2);

    const sidePanel = container.querySelector("#side-panel");
    const sideContent = container.querySelector("#side-content");
    const flipContainer = container.querySelector("#flipbook-container");

    container.querySelector("#close-panel-btn").onclick = () => {
      sidePanel.style.display = "none";
      flipContainer.classList.remove("shift-left");
    };

    container.querySelector("#overview-btn").onclick = () => {
      sidePanel.style.display = "block";
      flipContainer.classList.add("shift-left");
      sideContent.innerHTML='<h3 style="color: #ffffff;">Übersicht</h3>';


      for(let i=0; i<images.length; i+=2) {
        const row = document.createElement("div");
        row.className = "spread-row";

        const spread = document.createElement("div");
        spread.className = "spread-thumb";

        const imgLeft = document.createElement("img");
        imgLeft.src = images[i];
        spread.appendChild(imgLeft);

        if(i+1 < images.length) {
          const imgRight = document.createElement("img");
          imgRight.src = images[i+1];
          spread.appendChild(imgRight);
        }

        spread.addEventListener("click", () => { book.flip(i); });

        const label = document.createElement("div");
        label.className = "spread-label";
        label.textContent = i+"–"+(i+1 < images.length ? i+1 : i);

        row.appendChild(spread);
        row.appendChild(label);
        sideContent.appendChild(row);
      }
    };
  }

  // Shopify Section Render Event
  function waitForSection() {
    const container = document.querySelector(".flipbook-section");
    if(container) {
      initFlipbook(container);
    } else {
      // retry after delay
      setTimeout(waitForSection, 300);
    }
  }

  document.addEventListener("DOMContentLoaded", waitForSection);
})();
// Vollbild-Button Funktion
const fullscreenBtn = document.getElementById("fullscreen-btn");
const flipbookContainer = document.getElementById("flipbook-container");

fullscreenBtn.addEventListener("click", () => {
  if (!document.fullscreenElement) {
    flipbookContainer.requestFullscreen().catch(err => {
      console.error("Vollbildmodus konnte nicht gestartet werden:", err);
    });
  } else {
    document.exitFullscreen();
  }
});



